import { PageWrapper } from "../components/design-system/PageWrapper"
import { Navigation } from "../components/Navigation"

export const PrivacyPolicy = () => {
  return (
    <div>
      <Navigation />
      <PageWrapper>
        <h1>Privacy Policy</h1>
        <h3>Your Privacy Matters to Us</h3>
        <p>Last Updated: 2024-12-25</p>
        <p>
          Welcome to SmartWallet! We know how important your privacy is, and
          we’re committed to protecting your personal information. This Privacy
          Policy explains what information we collect, how we use it, and how we
          keep it safe. By using our site, you agree to this policy.
        </p>
        <h3>Information We Collect</h3>
        We collect information to make your experience on our site better and to
        provide you with personalized credit card recommendations. Here’s what
        we gather:
        <h4>a. Information You Share With Us</h4>
        <p>When you share your email with us:</p>
        <p>Your email and any details you share
        about your current credit cards or spending habits.</p>
        <h4>b. Information We Automatically Collect</h4>
        <li>
          Device Info: Like your IP address, browser type, and the kind of
          device you’re using.
        </li>
        <li>
          How You Use the Site: Pages you visit, how long you stay, and what you
          click on.
        </li>
        <h4>c. Cookies</h4>
        <p>We do not currently use cookies, but may in the future.</p>
        <h3>How We Use Your Info</h3>
        <p>Here’s how we put your information to good use:</p>
        <li>
          To Help You Find the Best Credit Cards: We tailor recommendations to
          your preferences.
        </li>
        <li>
          To Share Updates: With your permission, we might send you helpful
          emails about new features, tips, or offers.
        </li>
        <li>
          To Improve Our Site: We analyze how people use our site to make it
          better for everyone.
        </li>
        <h3>Who We Share Your Info With</h3>
        <p>We value your trust and promise never to sell your personal information.
        Here’s when we might share your info:</p>
        <li>
          Trusted Partners: With companies that help us run the site (like
          hosting services or analytics tools).
        </li>
        <li>Legal Stuff: If required by law or to protect our rights.</li>
        <li>
          If Our Business Changes: If we merge or sell the business, your info
          might transfer to the new owners.
        </li>
        {/* <h3>Your Choices and Control</h3>
        We want you to feel in control of your data. Here’s how you can manage
        it:
        <li>
          Opt-Out of Emails: Don’t want to hear from us? Click “unsubscribe” in
          any email.
        </li> */}
        {/* <li>
          Your Data Rights (for California Users): If you’re in California, you
          have additional rights like asking to see or delete your info. Reach
          out to us to learn more.
        </li>
 */}
        <h3>How We Keep Your Info Safe</h3>
        <p>We use top-notch security measures to keep your data safe. While no
        system is completely foolproof, we do everything we can to protect your
        information.</p>
        <h3>Links to Other Sites</h3>
        <p>Sometimes we link to other websites for your convenience. We’re not
        responsible for their privacy practices, so it’s a good idea to read
        their policies too.</p>
        <h3>For Our Younger Users</h3>
        <p>Our site is designed for adults, and we don’t knowingly collect
        information from anyone under 18. If you think a child has shared info
        with us, please let us know, and we’ll take care of it.</p>
        <h3>Updates to This Policy</h3>
        <p>We might update this policy occasionally to reflect changes to our
        services. We’ll always post updates here and let you know if anything
        major changes.</p>
        {/* <h3>Got Questions? We're Here to Help!</h3>
        If you have any questions or concerns, we’d love to hear from you. Feel free
         <a href="mailto:oksmartwallet@gmail.com">email</a> us */}
      </PageWrapper>
    </div>
  );
}
